import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { C, S } from './cedsStyles';

export default function CEDSLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail]         = useState('');
  const [password, setPassword]   = useState('');
  const [error, setError]         = useState('');
  const [info, setInfo]           = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [slow, setSlow]           = useState(false);

  async function handleSignIn() {
    setError(''); setInfo('');
    if (!email.trim() || !password) { setError('Email and password are required.'); return; }
    setSubmitting(true);
    setSlow(false);
    const slowTimer = setTimeout(() => setSlow(true), 6000);

    const { data: authData, error: authErr } = await supabase.auth.signInWithPassword({ email, password });
    clearTimeout(slowTimer);
    if (authErr) { setError(authErr.message); setSubmitting(false); return; }

    const { data: member, error: memberErr } = await supabase
      .from('ceds_council_members')
      .select('role, is_active')
      .eq('id', authData.user.id)
      .maybeSingle();

    if (memberErr || !member) {
      await supabase.auth.signOut();
      setError("Your account isn't set up yet. Contact PADD.");
      setSubmitting(false);
      return;
    }
    if (!member.is_active) {
      await supabase.auth.signOut();
      setError('Your account is inactive. Contact PADD.');
      setSubmitting(false);
      return;
    }

    navigate('/ceds/portal/discussions');
  }

  async function handleForgotPassword() {
    setError(''); setInfo('');
    if (!email.trim()) { setError('Enter your email address above first.'); return; }
    const { error: resetErr } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: `${window.location.origin}/ceds/accept-invite`,
    });
    if (resetErr) { setError(resetErr.message); return; }
    setInfo('Password reset email sent. Check your inbox.');
  }

  const inputStyle = { ...S.input, marginTop: 4 };

  return (
    <div style={{
      minHeight: '100vh', background: C.cream,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Nunito', 'Segoe UI', sans-serif", padding: 24,
    }}>
      <div style={{
        width: '100%', maxWidth: 400,
        background: C.white, borderRadius: 6,
        boxShadow: '0 4px 24px rgba(18,35,38,0.10)',
        overflow: 'hidden',
      }}>
        <div style={{ background: C.navy, padding: '28px 32px', textAlign: 'center' }}>
          <div style={{
            fontSize: 11, fontWeight: 700, color: C.gold,
            textTransform: 'uppercase', letterSpacing: '0.14em', marginBottom: 8,
          }}>
            Panhandle Area Development District
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, color: C.white, lineHeight: 1.3 }}>
            CEDS Strategy Council Portal
          </div>
        </div>

        <div style={{ padding: '28px 32px' }}>
          <div style={{ marginBottom: 16 }}>
            <label style={S.label}>Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="you@example.com"
              style={inputStyle}
              onKeyDown={e => e.key === 'Enter' && handleSignIn()}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={S.label}>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              style={inputStyle}
              onKeyDown={e => e.key === 'Enter' && handleSignIn()}
            />
          </div>

          {error && (
            <div style={{
              background: '#fdf0ed', border: `1px solid ${C.red}`,
              borderRadius: 4, padding: '9px 14px',
              fontSize: 13, color: C.red, marginBottom: 16,
            }}>
              {error}
            </div>
          )}
          {info && (
            <div style={{
              background: '#eafaf1', border: `1px solid ${C.green}`,
              borderRadius: 4, padding: '9px 14px',
              fontSize: 13, color: C.green, marginBottom: 16,
            }}>
              {info}
            </div>
          )}

          <button
            onClick={handleSignIn}
            disabled={submitting}
            style={{ ...S.btn.primary, width: '100%', padding: '11px', fontSize: 15, opacity: submitting ? 0.65 : 1 }}
          >
            {submitting ? (slow ? 'Almost there… please wait' : 'Signing in…') : 'Sign In'}
          </button>

          {slow && (
            <div style={{ fontSize: 12, color: C.muted, textAlign: 'center', marginTop: 10 }}>
              First sign-in of the day can take up to 20 seconds. Hang tight!
            </div>
          )}

          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <button
              onClick={handleForgotPassword}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                fontSize: 13, color: C.muted, textDecoration: 'underline',
              }}
            >
              Forgot password?
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
